module.exports = __webpack_public_path__ + "assets/img/c1d33f0764a6a78c7afbcb1de50b789e.png";